module.exports = __webpack_public_path__ + "img/1_icn_sneaker_selezionata.fc932192.png";